import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCorrelation = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7452 7.62167C12.7949 6.54632 10.3686 6.89048 8.79429 8.46576C8.78714 8.47291 8.77988 8.47996 8.77252 8.48689L7.52085 9.66557H9.00021C9.5525 9.66557 10.0002 10.1133 10.0002 10.6656C10.0002 11.2179 9.5525 11.6656 9.00021 11.6656H5.00021C4.83768 11.6656 4.68421 11.6268 4.54853 11.558C4.47952 11.5231 4.41379 11.4797 4.35291 11.4278C4.13712 11.2444 4.00021 10.971 4.00021 10.6656V6.66557C4.00021 6.11328 4.44793 5.66557 5.00021 5.66557C5.5525 5.66557 6.00021 6.11328 6.00021 6.66557V8.35033L7.39079 7.04085C9.59508 4.84498 12.9852 4.36731 15.7109 5.87027C17.5013 6.85749 18.7217 8.54324 19.1558 10.4428C19.2788 10.9812 18.9421 11.5174 18.4037 11.6404C17.8653 11.7634 17.3291 11.4267 17.206 10.8883C16.8956 9.52968 16.0235 8.32649 14.7452 7.62167Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41056 17.0428C11.3608 18.1181 13.7872 17.774 15.3615 16.1987C15.3686 16.1915 15.3759 16.1845 15.3832 16.1775L16.6349 14.9989L15.1556 14.9989C14.6033 14.9989 14.1556 14.5511 14.1556 13.9989C14.1556 13.4466 14.6033 12.9989 15.1556 12.9989L19.1556 12.9989C19.3181 12.9989 19.4716 13.0376 19.6072 13.1064C19.6762 13.1414 19.742 13.1848 19.8028 13.2366C20.0186 13.42 20.1556 13.6935 20.1556 13.9989L20.1556 17.9989C20.1556 18.5511 19.7078 18.9989 19.1556 18.9989C18.6033 18.9989 18.1556 18.5511 18.1556 17.9989L18.1556 16.3141L16.765 17.6236C14.5607 19.8194 11.1706 20.2971 8.44485 18.7942C6.65443 17.8069 5.43407 16.1212 5 14.2217C4.87697 13.6833 5.21369 13.147 5.7521 13.024C6.29051 12.901 6.82671 13.2377 6.94974 13.7761C7.26021 15.1348 8.1323 16.3379 9.41056 17.0428Z"
        />
      </svg>
    );
  }
);
